import React from 'react'

const CustomList = ({children}) => {
  return <ul>
    {children}
  </ul>
}

export default CustomList
